export default "__VITE_ASSET__CkQjt6OG__"